import { useCallback, useState } from 'react';
import { getText } from 'i18n/intl';
import {
  maintenanceLoading,
  messageMaintenanceResponse,
  runMaintenance,
} from 'slices/maintenance.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import type { TMaintenance } from '@timeedit/types/lib/types/maintenance.type';
import { Button } from '@timeedit/ui-components';
import {
  Radio,
  type RadioChangeEvent,
  Space,
  Tooltip,
} from '@timeedit/ui-components/antd';
import './component.scss';

type PropsMaintenance = {
  maintenance: TMaintenance[];
};

export const Maintenance = ({ maintenance }: PropsMaintenance) => {
  const dispatch = useAppDispatch();

  const messageMaintenance = useAppSelector(messageMaintenanceResponse);
  const loading = useAppSelector(maintenanceLoading);

  const [selected, setSelected] = useState(maintenance[0]?.id);
  const [showResult, setShowResult] = useState(false);

  const onChange = useCallback((event: RadioChangeEvent) => {
    setSelected(event.target.value);
    setShowResult(false);
  }, []);

  const onPerformMaintenance = useCallback(() => {
    dispatch(runMaintenance(selected));
    setShowResult(true);
  }, [dispatch, selected]);

  return (
    <div className="maintenance-wrapper">
      <div className="maintenance--wrapper">
        <Radio.Group
          value={selected}
          onChange={onChange}
          style={{ overflow: 'auto' }}
        >
          <Space direction="vertical">
            {maintenance?.map((item) => (
              <Radio key={item.id} value={item.id}>
                <Tooltip
                  title={() => (
                    <p style={{ margin: 0 }}>
                      {item.description.split(',').map((desc) => (
                        <>
                          {desc}
                          <br />
                        </>
                      ))}
                    </p>
                  )}
                  key={item.id}
                  placement="right"
                  overlayInnerStyle={{
                    width: 500,
                  }}
                >
                  {item.name}
                </Tooltip>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        <div className="block-code-response">
          <pre>
            <code>{showResult && !loading ? messageMaintenance : ''}</code>
          </pre>
        </div>
      </div>
      <div className="maintenance-between">
        <Button
          loading={loading}
          type="primary"
          onClick={onPerformMaintenance}
          style={{
            fontWeight: 900,
          }}
        >
          {getText('perform_maintenance')}
        </Button>
      </div>
    </div>
  );
};
